import React from 'react';
import { Popover, Fade, Popper } from '@mui/material';

interface PopoverProps {
  id: string | undefined;
  open: boolean;
  anchorEl: null | HTMLElement;
  handleClose?: () => void;
  children?: any;
  placement?: any;
}

const PopoverComponent=({ handleClose, id, open, anchorEl, children, placement }: PopoverProps)=> {
  return (
    <Popover
      className="simple-popover"
      sx={{
        '& .MuiPopover-paper': {
          display: 'flex',
          minWidth: '220px',
          padding: '16px 0px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '24px',
          borderRadius: '16px',
          background: '#FFF',
          boxshadow: '0px 12px 24px 0px rgba(0, 0, 0, 0.15)'
        }
      }}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      disableRestoreFocus
    >
      {children}
    </Popover>
  );
}
export default PopoverComponent